const normalizeStatus = (status = '') => String(status).trim().toLowerCase();

export const getStatusBadgeClass = (status) => {
  const normalizedStatus = normalizeStatus(status);

  if (normalizedStatus === 'completed') {
    return 'admin-badge admin-badge-status-completed';
  }

  if (['pending', 'pending_approval', 'planned'].includes(normalizedStatus)) {
    return 'admin-badge admin-badge-status-pending';
  }

  if (normalizedStatus === 'ongoing') {
    return 'admin-badge admin-badge-status-ongoing';
  }

  return 'admin-badge';
};
